import { Selector } from '@ngxs/store';
import { DetailEventsState, DetailEventsStateModel } from './detail-events.state';
import { EventDetailOutputDto } from '@smatchy/sdk';

export class DetailEventsSelector {
  @Selector([DetailEventsState])
  /** Absent before an activity is loaded, and absent again when it is gone. */
  static getEvent(state: DetailEventsStateModel): EventDetailOutputDto | null | undefined {
    return state.event;
  }

  @Selector([DetailEventsState])
  static loading(state: DetailEventsStateModel): boolean {
    return state.loading;
  }

  @Selector([DetailEventsState])
  static subscribeLoading(state: DetailEventsStateModel): boolean {
    return state.subscribeLoading;
  }

  @Selector([DetailEventsState])
  static ownershipTransferLoading(state: DetailEventsStateModel): boolean {
    return state.ownershipTransferLoading;
  }
}
